import { Button, Box } from "@mui/material";

import { getPlanExpiryText } from "../../utils/planUtils";

export default function CurrentPlanButton({ expiryDate, isMobile }) {
  return (
    <Box
      sx={{
        width: "100%",
        textAlign: "center",
      }}
    >
      <Button
        fullWidth
        variant='outlined'
        size={isMobile ? "small" : "large"}
        disabled
        sx={{
          borderColor: "#003D78",
          color: "#003D78",
          borderRadius: 2,
          textTransform: "none",
          fontWeight: 600,
          fontSize: {
            xs: "12px",
            lg: "13px",
          },
        }}
      >
        {getPlanExpiryText(expiryDate)}
      </Button>
    </Box>
  );
}
